module.exports = {
    myAccountPref: {
        substituteTitle: 'Substitute preferences',
        substituteText: 'Would you always like to opt-in for a substitute when an item you have ordered is not available?',
        successText: 'Your preferences have been saved successfully',
        commsTitle: 'Communication Preferences',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/myaccount.js